import { fmt } from './bamsShortsUtils';

/* ---------- location drill-down table ---------- */
export function LocTable({ rows }) {
    if (!rows.length) return <p className="sm">No ATS or QC-hold cases found for this SKU at this facility.</p>;
    const tot = rows.reduce((s, r) => s + (Number(r.units) || 0), 0);
    return (
        <>
            <table className="loctbl">
                <thead>
                    <tr>
                        <th className="item">Location</th>
                        <th>Type</th>
                        <th>Zone</th>
                        <th>Status</th>
                        <th className="n">Units</th>
                        <th className="n">Cases</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((r, i) => {
                        const isQC = String(r.status) === 'QC_AUDIT';
                        const unusable = r.usable === false;
                        return (
                            <tr key={`${r.location}|${i}`}>
                                <td className="item">
                                    <b>{r.location || '—'}</b>
                                    {r.aisle ? <span className="sm"> aisle {r.aisle}</span> : null}
                                </td>
                                <td className="sm">
                                    {String(r.locationType || '')
                                        .replace(/_/g, ' ')
                                        .toLowerCase()}
                                </td>
                                <td className="sm">{r.tempZone || '—'}</td>
                                <td>
                                    {isQC ? (
                                        <span className="inv-qc">QC hold</span>
                                    ) : unusable ? (
                                        <span className="inv-qc">unusable</span>
                                    ) : (
                                        <span className="inv-ok">ATS</span>
                                    )}
                                </td>
                                <td className="n">{r.units ? fmt(r.units) : <span className="sm">0</span>}</td>
                                <td className="n sm">{fmt(r.cases)}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            <p className="sm" style={{ marginTop: 6, whiteSpace: 'normal' }}>
                {fmt(tot)} units across {rows.length} location{rows.length > 1 ? 's' : ''}. Zero-unit rows are empty
                cases still assigned to the slot.
            </p>
        </>
    );
}
